/** Case-insensitive trimmed name key for per-user duplicate checks. */
export function normalizeReportingName(name: string): string {
  return name.trim().toLowerCase();
}

export function findDuplicateAnalysisName(
  analyses: { id: string; name: string }[],
  name: string,
  excludeId?: string
): string | null {
  const key = normalizeReportingName(name);
  if (!key) return null;
  const match = analyses.find(
    (a) => normalizeReportingName(a.name) === key && a.id !== excludeId
  );
  return match ? match.name : null;
}

export function findDuplicateDashboardName(
  dashboards: { id: string; name: string }[],
  name: string,
  excludeId?: string
): string | null {
  const key = normalizeReportingName(name);
  if (!key) return null;
  const match = dashboards.find(
    (d) => normalizeReportingName(d.name) === key && d.id !== excludeId
  );
  return match ? match.name : null;
}

export function suggestUniqueDashboardName(
  dashboards: { name: string }[],
  base = "Dashboard"
): string {
  const taken = new Set(dashboards.map((d) => normalizeReportingName(d.name)));
  let n = dashboards.length + 1;
  while (taken.has(normalizeReportingName(`${base} ${n}`))) {
    n += 1;
  }
  return `${base} ${n}`;
}
